import { render } from "./RecentErrors.vue?vue&type=template&id=92300a1a"
import script from "./RecentErrors.vue?vue&type=script&lang=js"
export * from "./RecentErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__